import React, { useState } from 'react';
import Modal from './Modal';
import Button from './Button';
import './GeoJsonUploadModal.css';

const GeoJsonUploadModal = ({ isOpen, onClose, onFileUpload }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (!selectedFile.name.toLowerCase().endsWith('.geojson') && 
          !selectedFile.name.toLowerCase().endsWith('.json')) {
        setError('Please upload a GeoJSON file (.geojson or .json)');
        setFile(null);
        return;
      }
      setFile(selectedFile);
      setError(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file');
      return;
    }

    setIsProcessing(true);
    setError(null);

    try {
      const text = await file.text();
      const geoJsonData = JSON.parse(text);

      // Validate GeoJSON structure
      if (!geoJsonData.type) {
        throw new Error('Invalid GeoJSON: missing "type" field');
      }

      if (geoJsonData.type === 'FeatureCollection' && !geoJsonData.features) {
        throw new Error('Invalid GeoJSON: FeatureCollection missing "features" array');
      }

      if (geoJsonData.type === 'Feature' && !geoJsonData.geometry) {
        throw new Error('Invalid GeoJSON: Feature missing "geometry" field');
      }

      onFileUpload(geoJsonData);
    } catch (err) {
      console.error('Error parsing GeoJSON:', err);
      setError(err.message || 'Failed to parse GeoJSON file. Please ensure it is valid JSON.');
      setIsProcessing(false);
    }
  };

  const handleClose = () => {
    setFile(null);
    setError(null);
    setIsProcessing(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Upload GeoJSON File">
      <div className="geojson-upload-modal">
        <div className="upload-instructions">
          <p>Please select a GeoJSON file (.geojson or .json) to display on the map.</p>
        </div>
        
        <div className="file-input-container">
          <input
            type="file"
            id="geojson-file-input"
            accept=".geojson,.json"
            onChange={handleFileChange}
            disabled={isProcessing}
            className="file-input"
          />
          <label htmlFor="geojson-file-input" className="file-input-label">
            {file ? file.name : 'Choose File'}
          </label>
        </div>

        {error && (
          <div className="upload-error">
            {error}
          </div>
        )}

        <div className="modal-actions">
          <Button
            variant="primary"
            onClick={handleUpload}
            disabled={!file || isProcessing}
          >
            {isProcessing ? 'Processing...' : 'Upload & View Map'}
          </Button>
          <Button
            variant="outline"
            onClick={handleClose}
            disabled={isProcessing}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default GeoJsonUploadModal;

